import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const inputCls = "w-full rounded-md border border-slate-300 px-3 py-2 text-sm";

export default function Settings() {
  const { user, can } = useAuth();
  const [info, setInfo] = useState(null);
  const [pw, setPw] = useState({ current_password: "", new_password: "" });

  useEffect(() => { api.get("/settings").then(({ data }) => setInfo(data)).catch((e) => toast.error(errMsg(e))); }, []);

  const changePw = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/change-password", pw); toast.success("Password changed successfully"); setPw({ current_password: "", new_password: "" }); }
    catch (e2) { toast.error(errMsg(e2)); }
  };

  const removeDemo = async () => {
    try { const { data } = await api.delete("/settings/demo-data"); toast.success(`${data.deleted} demo records removed`); setInfo({ ...info, demo_records: 0 }); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="space-y-5" data-testid="settings-page">
      <h1 className="font-serif text-3xl font-semibold text-[#0f2545] sm:text-4xl">Settings</h1>

      <div className="grid gap-4 lg:grid-cols-2">
        <div className="rounded-xl border border-slate-200 bg-white p-5">
          <h3 className="mb-3 text-base font-semibold text-[#0f2545] md:text-lg">System Information</h3>
          {info && Object.entries(info).map(([k, v]) => (
            <div key={k} className="flex justify-between border-b border-slate-100 py-2 text-sm">
              <span className="capitalize text-slate-500">{k.replace(/_/g, " ")}</span><span className="font-medium">{String(v)}</span>
            </div>
          ))}
          {can("delete") && info?.demo_records > 0 && (
            <button data-testid="remove-demo-btn" onClick={removeDemo} className="mt-4 rounded-md border border-rose-300 px-4 py-2 text-sm text-rose-700 hover:bg-rose-50">
              Remove {info.demo_records} demo records
            </button>
          )}
        </div>

        <form onSubmit={changePw} className="space-y-3 rounded-xl border border-slate-200 bg-white p-5">
          <h3 className="text-base font-semibold text-[#0f2545] md:text-lg">Change Password</h3>
          <p className="text-xs text-slate-500">Logged in as <strong>{user?.username}</strong> ({user?.role})</p>
          <input data-testid="current-password" type="password" required value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} placeholder="Current password" className={inputCls} />
          <input data-testid="new-password" type="password" required value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} placeholder="New password (min 6 chars)" className={inputCls} />
          <button data-testid="change-password-submit" className="rounded-md bg-[#0f2545] px-4 py-2 text-sm text-white">Change Password</button>
          <p className="pt-2 text-xs text-slate-500">Session timeout: 8 hours of inactivity requires re-login. Aadhaar and bank account numbers are masked for roles without unmask permission.</p>
        </form>
      </div>
    </div>
  );
}
